module.exports = __webpack_public_path__ + "assets/453fc8d846826b6c938d1a36a868b073.mp3";